import { render, staticRenderFns } from "./PerformancePersonSnapshotList.vue?vue&type=template&id=07ac4588&scoped=true&"
import script from "./PerformancePersonSnapshotList.vue?vue&type=script&lang=js&"
export * from "./PerformancePersonSnapshotList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ac4588",
  null
  
)

export default component.exports